import { produce } from 'immer'
import { ExtendCurrency, ExtendLocales } from 'src/enums'
import { TeamSize } from 'src/models/config.models'
import {
  GET_CONFIG_SUCCESS,
  GetConfigSuccessAction,
} from 'src/redux/actions/session.actions'

export interface ConfigState {
  departmentOptions: string[]
  departmentOptionsLocalized: string[]
  supportedLocales: ExtendLocales[]
  supportedCurrencies: ExtendCurrency[]
  supportedIndustries: string[]
  supportedIndustriesLocalized: string[]
  teamSizeOptions: TeamSize[]
  referralSourceOptions: string[]
  referralSourceOptionsLocalized: string[]
}

export const initialState: ConfigState = {
  departmentOptions: [],
  departmentOptionsLocalized: [],
  supportedLocales: [],
  supportedCurrencies: [],
  supportedIndustries: [],
  supportedIndustriesLocalized: [],
  teamSizeOptions: [],
  referralSourceOptions: [],
  referralSourceOptionsLocalized: [],
}

export type Actions = GetConfigSuccessAction

const ConfigReducer = (
  state: ConfigState = initialState,
  action: Actions,
): ConfigState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_CONFIG_SUCCESS: {
        draft.departmentOptions = action.payload.departmentOptions
        draft.departmentOptionsLocalized =
          action.payload.departmentOptionsLocalized
        draft.supportedLocales = action.payload.supportedLocales
        draft.supportedCurrencies = action.payload.supportedCurrencies
        draft.supportedIndustries = action.payload.supportedIndustries
        draft.supportedIndustriesLocalized =
          action.payload.supportedIndustriesLocalized
        draft.teamSizeOptions = action.payload.teamSizeOptions
        draft.referralSourceOptions = action.payload.referralSourceOptions
        draft.referralSourceOptionsLocalized =
          action.payload.referralSourceOptionsLocalized
        return draft
      }
    }
  })
}

export default ConfigReducer
